import { TextField, MenuItem } from '@mui/material'

interface Props {
  options: Array<{ value: string; label: string }>
  value: string
  onChange: (v: string) => void
  disabled?: boolean
}

export function DriverSelector({ options, value, onChange, disabled }: Props) {
  return (
    <TextField
      select
      size="small"
      label="Driver"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      sx={{ minWidth: 170 }}
    >
      {options.map((o) => (
        <MenuItem key={o.value} value={o.value}>
          {o.label}
        </MenuItem>
      ))}
    </TextField>
  )
}
